export const GIS_SRC_URL = 'https://accounts.google.com/gsi/client';
export const GAPI_SRC_URL = 'https://apis.google.com/js/api.js';
export const DISCOVERY_URL = 'https://sheets.googleapis.com/$discovery/rest?version=v4';
export const SCOPES = ['https://www.googleapis.com/auth/spreadsheets'];
